import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, Button, message } from 'antd';
import { newPasswordCheck, validatePhoneRequired, validatePhone } from '@/component/login/login_v5/validator';
import CountDownBtn from '@/component/login/login_v5/components/count-down-btn';
import NumberInput from '@/component/login/login_v5/components/number-input';
import { sendSMSCode } from '@/component/login/login_v5/utils';
import { Utils } from '@/tools/utils';
import './dialog-modify-pwd.less';

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};

class DialogModifyPwd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSend: false,
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.props.onOk) this.props.onOk(values);
            }
        });
    };

    handleSendSMSCode = () => {
        return new Promise((resolve, reject) => {
            const mobilePhone = Utils.getUserData().mobilePhone || '';
            sendSMSCode(mobilePhone)
                .then(res => {
                    if (res.status === 200){
                        this.setState({
                            isSend: true,
                        });
                        message.success('验证码已发送');
                        resolve();
                    } else {
                        reject('发送失败');
                    }
                });
        });
    }
    render() {
        const mobilePhone = Utils.getUserData().mobilePhone || '';
        const { isSend } = this.state;
        const { visible, onCancel, form, loading } = this.props;
        return (
            <Modal
                width="488px"
                title="修改密码"
                wrapClassName="dialog-modify-pwd"
                open={visible}
                footer={null}
                onCancel={() => {
                    if (onCancel) onCancel();
                }}
            >
                <div className="content">
                    {
                        visible && <Form {...layout} onSubmit={this.handleSubmit}>
                        <Form.Item>
                            {
                                form.getFieldDecorator('phone', {
                                    initialValue: mobilePhone,
                                    validateFirst: true,
                                    validateTrigger: !form.getFieldError('phone') ? 'onBlur' : 'onChange',
                                    rules: [
                                        validatePhoneRequired(),
                                        validatePhone()
                                    ]
                                })(
                                    <NumberInput
                                        disabled
                                        size="large"
                                        maxLength={11}
                                        placeholder="请输入手机号"
                                        onChange={(val) => {
                                            this.setState({
                                                sendBtnDisabled: String(val).length !== 11
                                            });
                                        }}
                                    />
                                )
                            }
                        </Form.Item>

                        <Form.Item
                            extra={isSend ? '验证码已发送，2分钟内输入有效' : undefined}
                        >
                            <div className='phone-input'>
                                {
                                    form.getFieldDecorator('captcha', {
                                        validateFirst: true,
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            {required: true, message: '请输入短信验证码'}
                                        ]
                                    })(
                                        <Input size="large" maxLength={6} placeholder="请输入短信验证码" />
                                    )
                                }
                                <CountDownBtn
                                    onCountStart={this.handleSendSMSCode}
                                    onCountEnd={()=>{
                                    }}
                                />

                            </div>
                        </Form.Item>
                        <Form.Item>
                            {form.getFieldDecorator('newPassword', {
                                validateFirst: true,
                                validateTrigger: 'onBlur',
                                rules: [
                                    {
                                        required: true,
                                        message: '请设置新密码'
                                    },
                                    newPasswordCheck(),
                                    {
                                        validator(_, value) {
                                            if (value && form.getFieldValue('replicaPassword')) {
                                                form.validateFields(['replicaPassword']);
                                            }
                                            return Promise.resolve();
                                        },
                                    }
                                ],
                            })(
                                <Input.Password
                                    size="large"
                                    maxLength={20}
                                    placeholder="设置新密码（6-20位，包含字母和数字）"
                                    visibilityToggle={Boolean(form.getFieldValue('newPassword'))}
                                    allowClear
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {form.getFieldDecorator('replicaPassword', {
                                validateFirst: true,
                                validateTrigger: 'onBlur',
                                rules: [
                                    {
                                        required: true,
                                        message: '请确认新密码'
                                    },
                                    {
                                        validator(_, value) {
                                            if (!value || form.getFieldValue('newPassword') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('输入的两次密码不一致'));
                                        },
                                    },
                                ],
                            })(
                                <Input.Password
                                    size="large"
                                    maxLength={20}
                                    placeholder="确认新密码"
                                    visibilityToggle={Boolean(form.getFieldValue('replicaPassword'))}
                                    allowClear
                                />
                            )}
                        </Form.Item>
                        <Form.Item {...tailLayout} style={{marginBottom: 0}}>
                            <Button
                                loading={loading}
                                type="primary"
                                size="large"
                                block
                                htmlType="submit"
                                className='submit-btn'
                            >
                                确认修改
                            </Button>
                        </Form.Item>
                    </Form>
                    }
                </div>
            </Modal>
        );
    }
}
const WrappedForm = Form.create()(DialogModifyPwd);
export default WrappedForm;